import { FormLabelProps } from '@chakra-ui/react';

export const simpleGray: FormLabelProps = {
  color: 'text.300',
  fontWeight: '600',
  fontSize: '14px',
  mb: 2,
  mr: 0,
};
